// extracted by mini-css-extract-plugin
module.exports = {"product_type_box_list":"ProductTypeBoxList_product_type_box_list__2bD54","product_type_box_image":"ProductTypeBoxList_product_type_box_image__3jM3B"};